import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import { motion } from "framer-motion";
import "./Projects.scss";

function ProjectCard({ project, index }) {
  const githubLink = project.links?.find((l) => l.label === "GitHub");

  return (
    <motion.article
      className="project-card"
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.18 }}
      transition={{ duration: 0.5, delay: index * 0.04 }}
    >
      <div className="project-card__title-row">
        <h3>{project.title}</h3>
        <div className="project-card__title-actions">
          <span className="project-card__status">{project.status}</span>
          {githubLink && (
            <a
              className="project-card__github"
              href={githubLink.href}
              target="_blank"
              rel="noreferrer"
              aria-label={`${project.title} on GitHub`}
            >
              <GitHubIcon fontSize="small" />
            </a>
          )}
        </div>
      </div>

      <p className="project-card__summary">{project.summary}</p>

      <ul className="project-card__impact">
        {project.impact.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <div className="project-card__stack" aria-label={`${project.title} stack`}>
        {project.stack.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
    </motion.article>
  );
}

export default ProjectCard;
